import { render, staticRenderFns } from "./AddingLamp.vue?vue&type=template&id=2db1ff80&scoped=true&"
import script from "./AddingLamp.vue?vue&type=script&lang=js&"
export * from "./AddingLamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1ff80",
  null
  
)

export default component.exports